<template>
    <div class="error-container">
      <h2>Imposible realizar el registro en este momento.</h2>
      <p>Sólo aquellos que participaron en la beta cerrada tienen acceso a esta función.</p>
      <img src="@/assets/FB_IMG_1735367713606.jpg" alt="No Login EXE" class="error-image" />
      <p>Pero no estés triste</p>
      <button @click="navigateTo('/furina')" class="discord-btn">
              Haz click aquí
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: "AppRegister",
    methods: {
      navigateTo(url) {
        window.location.href = url; // Cambia la página a la URL especificada
      },
    },
  };
  </script>
  
  <style>
  /* Agrega aquí los estilos específicos */
  </style>